export default __webpack_public_path__ + "static/media/InMemory.33357696.png";